// extracted by mini-css-extract-plugin
export default {"container":"XDcQnF","inPostPage":"OdeuKJ","noMargin":"WIEJ0e"};